import { render, staticRenderFns } from "./VenueWines.vue?vue&type=template&id=44821a42&scoped=true"
import script from "./VenueWines.vue?vue&type=script&lang=js"
export * from "./VenueWines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44821a42",
  null
  
)

export default component.exports